// layout/AppLayout.tsx
import React from "react";
import { Layout } from "antd";
import { Outlet, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Login from "../Login";
import Register from "../Register";
import Sider from "./Sider";
import Header from "./Header";
import FloatingShortcutButton from "../../components/Orders/FloatingShortcutButton";

const { Content } = Layout;

const AppLayout: React.FC = () => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    // Unauthenticated layout with react-router routes inside
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content
        // style={{
        //   display: "flex",
        //   justifyContent: "center",
        //   alignItems: "center",
        // }}
        >
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Content>
      </Layout>
    );
  }

  // Authenticated layout with header, sider, and content
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider />
      <Layout>
        <Header />
        <Content
          style={{
            padding: "24px",
            background: "#fff",
            height: "calc(100vh - 111px)",
          }}
          className="rounded-md overflow-y-auto"
        >
          <FloatingShortcutButton />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
